export function maskCardNumber(cardNumber: string) {
  if (!cardNumber) return '';

  const last4Digits = cardNumber.replace(/\s/g, '').slice(-4);

  return `**** ${last4Digits}`;
}

export function maskEmail(email: string) {
  const [name, domain] = email.split('@');

  if (!name || !domain) return email;

  if (name.length <= 2) {
    return `${name[0]}*@${domain}`;
  }

  const first = name[0];
  const last = name[name.length - 1];
  const mask = '****';

  return `${first}${mask}${last}@${domain}`;
}

export function maskPhoneNumber(phoneNumber: string) {
  if (!phoneNumber) return '';

  const last4Digits = phoneNumber.replace(/\s/g, '').slice(-4);

  return `*** ${last4Digits}`;
}
